import { makeUpdateLimitOperation } from './make-update-limit-operation';
import { LimitFormValue, LimitScope, LimitType } from './types';

export const getUpdateLimitOperation = (
  configurationId: string,
  configuration: LimitFormValue | Omit<LimitFormValue, 'timePeriod'>,
  limitScope: LimitScope,
  limitType: LimitType,
) => {
  if (configuration.isEnabled && typeof configuration.limit === 'number') {
    return makeUpdateLimitOperation(
      configurationId,
      {
        limit: configuration.limit,
        timePeriod: 'timePeriod' in configuration ? configuration.timePeriod : undefined,
      },
      limitType,
      limitScope,
    );
  }

  return null;
};
